import { render, staticRenderFns } from "./CreateClient.vue?vue&type=template&id=47569c07&scoped=true"
import script from "./CreateClient.vue?vue&type=script&lang=js"
export * from "./CreateClient.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CreateClient.vue?vue&type=style&index=1&id=47569c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47569c07",
  null
  
)

export default component.exports